import { cloneDeep, get, find, set, unset, isFinite, isEmpty, isEqual } from 'lodash';
import { Series, Vif } from 'common/visualizations/vif';
import { BASE_LAYERS, VECTOR_BASEMAP_STYLES } from 'common/authoring_workflow/constants';

export function migrateVif8ToVif9(vifToMigrate: any): Vif {
  const migratedVif = cloneDeep(vifToMigrate);

  migratedVif.series.forEach((_series: Series, index: number) => {
    const vizType = migratedVif.series[index].type;

    if (['featureMap', 'regionMap'].includes(vizType)) {
      unset(migratedVif, '');

      let basemapStyle = get(vifToMigrate, 'configuration.baseLayerUrl', VECTOR_BASEMAP_STYLES.basic.value);
      const mapStyleConfig = find(BASE_LAYERS, { legacyMapsTileUrlValue: basemapStyle });
      if (mapStyleConfig) {
        basemapStyle = get(mapStyleConfig, 'value');
      }

      const basemapOpacity = get(vifToMigrate, 'configuration.baseLayerOpacity', 1);
      const pointOpacity =
        parseFloat(get(vifToMigrate, `series[${index}].mapOptions.pointOpacity`)) * 100 || 100;
      const flyoutColumnName = get(vifToMigrate, 'configuration.rowInspectorTitleColumnName', null);
      set(migratedVif, `series[${index}].type`, 'map');
      set(migratedVif, `series[${index}].mapOptions.mapType`, 'pointMap');

      if (isEqual('regionMap', vizType)) {
        set(migratedVif, `series[${index}].mapOptions.pointAggregation`, 'region_map');
      }
      set(migratedVif, 'configuration.basemapOptions.basemapStyle', basemapStyle);

      set(migratedVif, 'configuration.basemapOptions.basemapOpacity', basemapOpacity);
      set(
        migratedVif,
        `series[${index}].mapOptions.pointOpacity`,
        isFinite(pointOpacity) ? pointOpacity : null,
      );

      if (!isEmpty(flyoutColumnName)) {
        set(migratedVif, `series[${index}].mapOptions.mapFlyoutTitleColumnName`, flyoutColumnName);
      }
    }
  });

  migratedVif.format.version = 9;
  return migratedVif;
}
